import { defineMessages } from "react-intl";

export const scope = "components.HistoryDetailsWithholdingsWithholding";

export const messages = defineMessages({
  copySuccess: {
    id: `${scope}.copySuccess`,
    defaultMessage: "Copiado con exito",
  },
  agreementLabel: {
    id: `${scope}.agreementLabel`,
    defaultMessage: "Concertado",
  },
  liquidationLabel: {
    id: `${scope}.liquidationLabel`,
    defaultMessage: "Liquidado",
  },
  descritionLabel: {
    id: `${scope}.descritionLabel`,
    defaultMessage: "Instrumento / Código Especie",
  },
  quantityLabel: {
    id: `${scope}.quantityLabel`,
    defaultMessage: "Cantidad",
  },
  priceLabel: {
    id: `${scope}.priceLabel`,
    defaultMessage: "Precio",
  },
  grossLabel: {
    id: `${scope}.grossLabel`,
    defaultMessage: "Importe Bruto",
  },
  valuationLabel: {
    id: `${scope}.valuationLabel`,
    defaultMessage: "Importe Neto",
  },
  marketRightLabel: {
    id: `${scope}.marketRightLabel`,
    defaultMessage: "Derecho de mercado",
  },
  ivaLabel: {
    id: `${scope}.ivaLabel`,
    defaultMessage: "IVA",
  },
});
